import React from 'react';
import PropTypes from 'prop-types';

import {Field} from 'redux-form';
import FieldCheckboxGroup from '../../fields/fieldCheckboxGroup/FieldCheckboxGroup';

export default function ConstructedCheckboxGroupField({field}) {
  return (
    <Field
      name={field.code}
      label={`${field.name} ${field.required ? '*' : ''}`}
      choices={field.choices}
      required={field.required}
      component={FieldCheckboxGroup}
    />
  );
}

ConstructedCheckboxGroupField.defaultValue = FieldCheckboxGroup.defaultValue;



// WEBPACK FOOTER //
// ./components/constructedForm/fields/ConstructedCheckboxGroupField.js